import { EnvelopeSimpleIcon } from '@phosphor-icons/react'
import clsx from 'clsx'
import Link from 'next/link'
import { PageInfo } from '@/src/@types/models'
import WhatsappIcon from '@/src/components/core/icons/WhatsappIcon'
import { Block } from '@/src/lib/PageBuilder'

export default function Component({
  pageInfo,
  blocks,
  index,
}: {
  pageInfo: PageInfo
  blocks: Block[]
  index: number
}) {
  return (
    <div
      className={clsx(
        'relative overflow-hidden bg-linear-to-b from-gray-50 to-gray-100 px-5 py-16 md:py-24',
        {
          'mt-20 md:mt-32':
            pageInfo.newSpacing &&
            blocks[index - 1]?.block !== 'flch_trial_lesson_cta',
        }
      )}
    >
      <div className="relative z-10 mx-auto max-w-240">
        <h2 className="text-4xl font-black md:text-center md:text-20xl">
          Du hast Fragen? Kontaktiere uns!
        </h2>
        <p className="mt-4 md:mt-6 md:text-center">
          Du erreichst uns von Montag bis Freitag: 08.00 – 12:00 und 13:00 –
          17.00 Uhr und am Samstag 8:00 – 12:00 Uhr
        </p>
        <div className="mt-6 divide-y divide-gray-200 text-gray-800 md:mt-12 md:flex md:divide-x md:divide-y-0">
          <Link
            href="https://wa.me/41315391065?text=Liebes%20fahrlehrer.ch%20Team%2C%20"
            className="flex items-center space-x-4 py-4 md:flex-1 md:justify-center md:px-6"
          >
            <WhatsappIcon size={32} className="shrink-0" />
            <div>
              <p className="text-sm">WhatsApp</p>
              <p className="mt-1 font-bold md:text-lg">031 539 10 65</p>
            </div>
          </Link>
          <Link
            href="mailto:mail@fahrlehrer.ch"
            className="flex items-center space-x-4 py-4 md:flex-1 md:justify-center md:px-6"
          >
            <EnvelopeSimpleIcon size={32} weight="bold" className="shrink-0" />
            <div>
              <p className="text-sm">E-Mail</p>
              <p className="mt-1 font-bold md:text-lg">mail@fahrlehrer.ch</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
